export const CanvasConnection = {
  flow: 'x',
  ActiveCanvasUsers: {},
  ConnectionNavbar: {},
  gap: 'Z2',
};